import React, { useEffect, useRef } from "react"
import { Animated, Easing, StyleSheet, TouchableOpacity, View } from "react-native"
import { Text } from "../Text/Text"
import { BUTTON_ANIMATED, TEXT, VIEW, buttonPresets } from "./Switch.presets"
import { SwitchProps } from "./Switch.props"

export const Switch = (props: SwitchProps) => {
  const {
    value,
    onValueChange,
    onSameValuePress,
    options,
    style: styleOverride,
    buttonStyle: buttonStyleOverride,
    buttonActiveStyle: buttonActiveStyleOverride,
    buttonWidth = 150,
  } = props;

  const animatedValue = useRef(
    new Animated.Value(options.findIndex((o) => o.id === value))
  ).current;

  const viewStyle = StyleSheet.flatten([VIEW, styleOverride]);

  const width = buttonWidth ? { width: buttonWidth } : undefined;

  const buttonActiveStyle = StyleSheet.flatten([
    buttonPresets['active'],
    buttonStyleOverride,
    width,
  ]);

  const buttonInactiveStyle = StyleSheet.flatten([
    buttonPresets['inactive'],
    buttonStyleOverride,
    width,
  ]);

  const activeTextStyle = StyleSheet.flatten([TEXT, props.activeTextStyle]);
  const inactiveTextStyle = StyleSheet.flatten([TEXT, props.inactiveTextStyle]);

  const buttonAnimatedStyle = StyleSheet.flatten([
    BUTTON_ANIMATED,
    {
      transform: [
        {
          translateX:
            animatedValue &&
            animatedValue.interpolate({
              inputRange: [0, 1],
              outputRange: [4, buttonWidth + 8],
            }),
        },
      ],
    },
    buttonStyleOverride,
    buttonActiveStyleOverride,
    width,
  ]);

  const animate = (val: Animated.Value, toValue: number): void => {
    // animatedValue.setValue(last)
    Animated.timing(val, {
      toValue: toValue,
      duration: 100,
      easing: Easing.cubic,
      useNativeDriver: true,
    }).start();
  };

  const toggleItem = (val: string) => {
    if (val !== value) {
      onValueChange(val);
    } else if (onSameValuePress != null) {
      onSameValuePress();
    }
  };

  useEffect(() => {
    if (animatedValue) {
      animate(
        animatedValue,
        options.findIndex((o) => o.id === value)
      );
    }
  }, [value, animatedValue]);

  return (
    <View style={viewStyle}>
      <Animated.View style={buttonAnimatedStyle} />
      {options.map((opt) => {
        const active = value === opt.id;

        return (
          <TouchableOpacity
            key={opt.id}
            style={active ? buttonActiveStyle : buttonInactiveStyle}
            onPress={() => toggleItem(opt.id)}
          >
            <Text
              preset={active ? 'bold' : 'default'}
              style={active ? activeTextStyle : inactiveTextStyle}
            >
              {opt.label}
            </Text>
          </TouchableOpacity>
        );
      })}
    </View>
  );
};
